import React from "react";

const Why = () => {
  const benefits = [
    {
      title: "Productivity",
      desc: "Use AI to automate routine tasks, streamline workflows, and free up time for high-value work."
    },
    {
      title: "Automation",
      desc: "Learn how to design and integrate AI-powered automations that scale with your role and organization."
    },
    {
      title: "Leadership",
      desc: "Develop the strategic insight to lead AI conversations, influence decisions, and future-proof your career."
    },
    {
      title: "Community",
      desc: "Join a network of ambitious professionals learning, experimenting, and growing together with AI."
    }
  ];

  return (
    <section className="bg-white py-10 sm:py-20 lg:py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-thin tracking-wide mb-4 sm:mb-6 text-black">
            Why Choose Our <span className="text-gray-600">AI Programs</span>
          </h2>
          <div className="w-24 sm:w-32 h-px bg-black mx-auto mb-6 sm:mb-8" />
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Designed for busy professionals who want more than theory - practical skills, real outcomes, and lasting impact.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center group">
              <div className="w-2 h-2 bg-black rounded-full mx-auto mb-6 sm:mb-8 group-hover:scale-150 transition-transform duration-300" />
              <h3 className="text-xl sm:text-2xl font-thin tracking-wide mb-4 sm:mb-6 text-black group-hover:text-gray-600 transition-colors">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-sm">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Why;
